// removed by extract-text-webpack-plugin
module.exports = {"inputGroup":"tZY7muKZRT8oZXaGsCj2N","label":"_361A15nzsyGW5gfQxVtr0y"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/form-elements/radio-button.scss
// module id = 85
// module chunks = 0